module.exports = __webpack_public_path__ + "img/checkmark.0c0891f6.svg";